/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $LeagueListMinimum = {
    properties: {
        tableRating: {
            type: 'LeagueRatingEnum',
            isRequired: true,
        },
        main: {
            type: 'boolean',
            isRequired: true,
        },
        category: {
            type: 'LeagueCategoryEnum',
            isRequired: true,
        },
        officialName: {
            type: 'string',
            isRequired: true,
        },
        internalName: {
            type: 'string',
            isRequired: true,
        },
        id: {
            type: 'number',
            isRequired: true,
        },
        name: {
            type: 'Translation',
            isRequired: true,
        },
        subCategory: {
            type: 'SubCategory',
            isRequired: true,
        },
    },
} as const;
